<template>
  <div class="w-full">
    <div
      class="relative border-1 rounded-2xl min-w-full min-h-[100vh] tablet:min-h-[60vh] 2xl:min-h-[80vh] flex flex-col gap-2 px-2 pt-[140px] tablet:pt-[80px] laptop:pt-[30px] pb-5 border-gray-300">

      <div
        class="mobile:left-0 mx-auto flex flex-col-reverse laptop:flex-row justify-between items-center gap-2.5 tablet:gap-2 absolute -top-6 right-0 tablet:left-auto w-full px-2.5 laptop:px-[15px]">
        <div class="w-full laptop:w-1/2 flex flex-col tablet:flex-row gap-[10px] tablet:gap-[15px]">
          <div
            class="relative w-full tablet:w-1/2 flex items-center !rounded-full 2xl:!rounded-full overflow-hidden border !border-customGray h-max pr-[0.5rem] bg-[#fff] shadow-[0px_0px_10px_0px_#00000026]">
            <dateRangePicker ref="datePicker" v-model="selectedDate" :value="selectedDate" :disable-future="false"
              @change="onDateChange"
              input-class="!p-[10px] 2xl:!px-[15px] 2xl:!py-[0px] !text-[14px] !h-[44px] date-picker mx-input cursor-pointer  focus:outline-none w-full border-0" />
            <img src="../../assets/images/calendar-icon.svg" alt="Calendar Icon" @click="openDatePicker"
              @mousedown.stop
              class="w-[26px] h-[26px] object-contain cursor-pointer">
          </div>

          <div class="relative w-full tablet:w-1/2 flex gap-[15px] justify-between tablet:justify-start items-center ">
            <div class="w-[95%] tablet:w-[85%] shadow-[0px_0px_10px_0px_#00000026] rounded-full">
              <SingleSelectDropdown :options="options" optionKey="title" selectValueKey="value"
                input-class="!p-[10px] 2xl:!px-[15px] 2xl:!py-[0px] !text-[14px] !h-[44px] date-picker mx-input cursor-pointer focus:outline-none !bg-white w-full rounded-full text-left"
                :selectedOptions="selectedOption" :updateOption="(option, data) => setSelectedOption(data)"
                fieldName="Date Option" :isSearchable="false"></SingleSelectDropdown>
            </div>
            <button type="button" @click="resetClicked"
              class="group disabled:cursor-not-allowed cursor-pointer min-w-[40px] min-h-[40px] max-w-[40px] max-h-[40px]">
              <img src="../../assets/images/reset-date.png" alt="icon"
                class="group-disabled:block hidden w-full object-contain">
              <img src="../../assets/images/reset-icon-enable.png" alt="icon"
                class="group-disabled:hidden block w-full object-contain">
            </button>
          </div>
        </div>
        <div class="w-full laptop:w-1/2 flex justify-between laptop:justify-end gap-[15px]">
          <entities :modelValue="limit" @update:modelValue="onLimitChange" globalEntitiesClass="" />
          <searchInput :globalSearchClass="'w-full tablet:w-[72%] laptop:w-[50%] largeDesktop:w-[55%]'"
            :input-class="'rounded-full shadow-[0px_0px_10px_0px_#00000026] pl-3 pr-16 py-3 w-full h-10 bg-white disabled:!bg-white disabled:opacity-100 focus:outline-none text-sm'"
            :buttonclass="'absolute top-[5px] right-[5px] w-[30px] h-[30px]'" :img-src="require('@/assets/images/search-icon-01.png')"
            :clearClass="'absolute top-0 flex items-center justify-center !h-[100%] right-[2.2rem] laptop:w-4 laptop:h-4 largeDesktop:w-6 largeDesktop:h-6'"
            v-model="search" @input="onSearch" :onClear="onClearSearch" :readonly="loading" :clearable="true" />
        </div>
      </div>
      <div class="block laptop:hidden">
        <div v-if="tableItems.length > 0" class="mt-2 min-h-[50vh]">
          <listings v-for="(item, index) in tableItems" :key="index" :item="item" />
        </div>
        <div v-else>
          <h6 class="flex justify-center items-center text-[20px] laptop:text-[30px] min-h-[60vh] 2xl:min-h-[80vh] m-0 text-[#333333]"
            v-if="addresses == null || (addresses && addresses.length == 0)"> No Record Found</h6>
        </div>
      </div>
      <div class="mt-2 laptop:block hidden">
        <commisionTable :tableHeaders="tableHeaders" :tableData="tableItems" :sortClicked="sortClicked" />
      </div>
    </div>
    <!-- <div class="flex justify-center relative -top-5">
      <customPagination />
    </div> -->
    <div v-if="tableItems && tableItems.length > 0"
      class="flex mobile:flex-col tablet:flex-row mobile:gap-3 tablet:gap-0 items-center justify-between relative -top-5 px-3">
      <paginationEntries class="mobile:hidden tablet:block" :currentPage="page" :perPage="limit"
        :totalItems="totalItems" />
      <customPagination :page="page" :total_pages="total_pages" :updatePage="updatePage" />
    </div>
  </div>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import entities from "../../components/showEntities/entities.vue";
import searchInput from '../../components/partialComponent/customInput.vue';
import listings from './commisionsList.vue';
import commisionTable from './commisionsTable.vue';
// import createQoute from "../../components/createQuote/createQuote.vue";
import customPagination from "../../components/partialComponent/customPagination.vue";
import paginationEntries from "../../components/partialComponent/pagination-entries.vue";
import dateRangePicker from "../../components/partialComponent/DateRangePicker.vue";
import moment from "moment";
import SingleSelectDropdown from "../../components/partialComponent/singleSelectDropdown.vue";


export default {
  components: {
    entities,
    searchInput,
    commisionTable,
    // createQoute,
    customPagination,
    listings,
    paginationEntries,
    dateRangePicker,
    SingleSelectDropdown
  },
  data() {
    return {
      limit: 25,
      search: "",
      page: 1,
      total_pages: 0,
      totalItems: 0,
      debounceTimer: null,
      loading: false,
      tableHeaders: [],
      tableItems: [],
      selectedSort: {
        "column": "agreement_id",
        "direction": "DESC"
      },
      selectedDate: this.getYearToDate(),
      selectedOption: '',
      options: [{
        "value": "created_at",
        "title": "Sales Date"
      },
      {
        "value": "paid_at",
        "title": "Process Date"
      }]
    }
  },
  computed: {
    ...mapGetters([
      "commissionsList",
    ]),
  },
  watch: {
    commissionsList: function (data) {
      this.loading = false
      // this.list = this.commissionsList.body
      // this.tableItems = []
      this.tableItems = this.commissionsList.body
      this.total_pages = this.commissionsList.paging.total_pages
      this.totalItems = this.commissionsList.paging.total_records
    },
  },
  mounted() {
    this.setTableHeaders();
    this.loading = true
    this.getCommissionsList(this.getRequestParams())

  },
  methods: {


    ...mapActions([
      "getCommissionsList","getComissionSummary"
    ]),
    onDateChange(data) {
      this.page = 1
      this.selectedDate = data.dates
      this.getCommissionsList(this.getRequestParams())
    },
    getYearToDate() {
      return [
        moment().startOf("year").format("MM/DD/YYYY"),
        moment().format("MM/DD/YYYY")
      ];
    },
    updatePage(page) {
      if (page == this.page) return
      this.page = page
      this.loading = true
      this.getCommissionsList(this.getRequestParams())
    },
    onSearch() {
      clearTimeout(this.debounceTimer);
      // Start new debounce timer

      this.page = 1
      this.debounceTimer = setTimeout(() => {
        if (this.search.length == 0 || this.search.trim().length > 0) {
          this.loading = true
          this.getCommissionsList(this.getRequestParams())
        }
      }, 1000); // 1200ms delay
    },
    onClearSearch() {
      clearTimeout(this.debounceTimer);
      this.page = 1
      this.search = ''
      this.loading = true
      this.getCommissionsList(this.getRequestParams())

    },
    onLimitChange(newLimit) {
      this.limit = newLimit;
      this.page = 1;
      this.loading = true;
      this.getCommissionsList(this.getRequestParams())
    },
    setTableHeaders() {
      this.tableHeaders = [
        this.getTableHeaderObject("ID", "agreement_id", "agreement_id", "", "1"),
        this.getTableHeaderObject("Consumer", "consumer_name", "consumer_name", "", "1"),
        this.getTableHeaderObject("Plan", "plan_name", "plan_name", "", "1"),
        this.getTableHeaderObject("Seller", "sold_by_name", "sold_by_name", "", "1"),
        this.getTableHeaderObject("Sales Date", "created_at", "created_at", "", "1"),
        this.getTableHeaderObject("Process Date", "paid_at", "paid_at", "", "1"),
        this.getTableHeaderObject("Amount", "total_amount", "total_amount", "", "1"),
        this.getTableHeaderObject("Status", "status_text", "status_text", "", "1"),
      ]
      this.setSort()
    },
    getTableHeaderObject(title, data_value, sort_column, sort_direction, sort_applicable, isHeaderToolTipShow = 0, tooltip_text = '') {
      return {
        title: title,
        data_value: data_value,
        sort_column: sort_column,
        sort_direction: sort_direction,
        sort_applicable: sort_applicable,
        isHeaderToolTipShow: isHeaderToolTipShow,
        tooltip_text: tooltip_text
      }
    },
    setSort() {
      this.tableHeaders.map(obj => {
        if (obj.sort_column == this.selectedSort.column) {
          obj.sort_direction = this.selectedSort.direction;
        } else {
          obj.sort_direction = "";
        }
      });
    },
    sortClicked(item) {
      if (item.sort_applicable == '1') {
        this.page = 1
        if (item.sort_column == this.selectedSort.column) {
          this.selectedSort.direction = item.sort_direction == "DESC" ? "ASC" : "DESC"
          item.sort_direction = this.selectedSort.direction
        } else {
          this.tableHeaders.map(obj => {
            obj.sort_direction = "";
          });
          this.selectedSort.column = item.sort_column
          this.selectedSort.direction = item.sort_direction == "DESC" ? "ASC" : "DESC"
          item.sort_direction = this.selectedSort.direction
        }
        this.getCommissionsList(this.getRequestParams())
      }
    },

    getRequestParams() {
      let payload = {
        search: this.search,
        limit: this.limit,
        page: this.page,
        sort: this.selectedSort,
        date_range: `${this.selectedDate[0]} - ${this.selectedDate[1]}`
      }

      if (!this.$helper.isEmpty(this.selectedOption)) {
        payload['date_option'] = this.selectedOption
      }

      this.getComissionSummary(payload)

      return payload
    },

    setSelectedOption(data) {
      this.selectedOption = data
      this.getCommissionsList(this.getRequestParams())
    },

    openDatePicker() {
      if (this.$refs.datePicker) {
        this.$refs.datePicker.openDatePicker();
      }
    },

    resetClicked() {
      this.limit = 25,
        this.search = "",
        this.page = 1,
        this.loading = false,
        this.selectedSort = {
          "column": "agreement_id",
          "direction": "DESC"
        },
        this.selectedDate = this.getYearToDate(),
        this.selectedOption = '',
        this.setSort()
        this.getCommissionsList(this.getRequestParams())
    }
  },
};
</script>